class ApiResult {
	data: any;
	httpStatus: number;
}

export const post = async (url, data) => {
	// @ts-ignore
	return new Promise<ApiResult>(resolve => {
		const params = new FormData();

		for (const key in data) {
			params.append(key, data[key]);
		}

		// @ts-ignore
		MeddiApp.ajax.request(
			'POST',
			url,
			params,
			result => {
				resolve({
					httpStatus: 200,
					data: result,
				});
			},
			undefined,
			undefined,
			false,
		);
	});
};

export const get = async url => {
	// @ts-ignore
	return new Promise<ApiResult>(resolve => {
		// @ts-ignore
		MeddiApp.ajax.request(
			'GET',
			url,
			null,
			result => {
				resolve({
					httpStatus: 200,
					data: result,
				});
			},
			undefined,
			undefined,
			true,
		);
	});
};

export default { get, post };
